// selectors.js
import { createSelector } from 'reselect';

const getJobworkMemo = (state) => state.jobworkDatalist.jobMemo;
export const selectJobworkMemo = createSelector(
  [getJobworkMemo],
  (jobMemo) => jobMemo || { data: [] }
);

const getDeptEmpJobwork = (state) => state.jobworkDatalist.deptEmp;
export const selectDeptEmpJobwork = createSelector(
  [getDeptEmpJobwork],
  (deptEmp) => deptEmp || { data: [] }
);

const getJobworkData = (state) => state.jobworkDatalist.jobdata;
export const selectJobworkPaymentData = createSelector(
  [getJobworkData],
  (jobdata) => jobdata || { data: [] }
);


const getAdvancePayment = (state) => state.jobworkDatalist.advamt;
export const selectAdvancePayTypes = createSelector(
  [getAdvancePayment],
  (jobdata) => jobdata || { data: [] }
);

const getPaymentMemo2 = (state) => state.PaymentDatalist.paymemo;
export const selectPaymentMemo = createSelector(
  [getPaymentMemo2],
  (paymemo) => paymemo || { data: [] }
);

const getPaymentData = (state) => state.PaymentDatalist.paydata;
export const selectPaymentData = createSelector(
  [getPaymentData],
  (paydata) => paydata || { data: [] }
);

const getPrevBalEmpAmt = (state) => state.PaymentDatalist.prevbal;
export const selectPrevBalEmpAmt = createSelector(
  [getPrevBalEmpAmt],
  (paydata) => paydata || { data: [] }
);